const TRUSTED_HOST_SUFFIXES = ['newtail.com.br', 'vtex.com']

const BLOCKED_PROTOCOL_PREFIXES = ['javascript:', 'data:', 'vbscript:', 'file:']

const isDevelopmentEnv = () => {
  const NODE_ENV = process.env.NODE_ENV
  const REACT_APP_ENV = process.env.REACT_APP_ENV

  return REACT_APP_ENV === 'development' || NODE_ENV === 'development'
}

function getTrustedHostPatterns(): string[] {
  const patterns = [...TRUSTED_HOST_SUFFIXES]
  const { BFF_RETAIL_MEDIA: bff } = process.env

  if (!bff) return patterns

  try {
    const { hostname } = new URL(bff)
    if (hostname && !patterns.includes(hostname)) {
      patterns.push(hostname)
    }
  } catch {
    // ignore invalid BFF URL
  }

  return patterns
}

function hostnameMatchesTrustedPattern(
  hostname: string,
  patterns: string[]
): boolean {
  const normalized = hostname.toLowerCase()

  return patterns.some(pattern => {
    const trusted = pattern.toLowerCase()
    return normalized === trusted || normalized.endsWith(`.${trusted}`)
  })
}

export function isSafeCreativeStudioEmbedUrl(url: string): boolean {
  const trimmed = url.trim()
  if (!trimmed) return false

  const lower = trimmed.toLowerCase()
  if (BLOCKED_PROTOCOL_PREFIXES.some(prefix => lower.startsWith(prefix))) {
    return false
  }

  let parsed: URL
  try {
    parsed = new URL(trimmed)
  } catch {
    return false
  }

  if (parsed.username || parsed.password) return false

  const allowedProtocols = isDevelopmentEnv() ? ['https:', 'http:'] : ['https:']
  if (!allowedProtocols.includes(parsed.protocol)) return false

  if (isDevelopmentEnv()) return true

  return hostnameMatchesTrustedPattern(
    parsed.hostname,
    getTrustedHostPatterns()
  )
}
